import React, { forwardRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Input, Select, InputNumber } from 'antd'

import * as Constants from '../../../constants'
import { Col, Grid, Row } from 'react-flexbox-grid'

const { Option } = Select

const FormOutsourcing = forwardRef((props, ref) => {
    const {loading, onSubmitOutsourcing, isEditing, outsourcingToEdit } = props
    const [form] = Form.useForm()
    const [categories, setCategories] = useState({})

    useEffect(() => {
        const categories = {}
        Object.keys(Constants.categoryARCASABidOrderMap).forEach(key => {
            categories[key] = Constants.categoryARCASABidOrderMap[key]
        })
        Object.keys(Constants.categorySDBidOrderMap).forEach(key => {
            categories[key] = Constants.categorySDBidOrderMap[key]
        })
        setCategories(categories)
    }, [])

    const handleSubmit = values => {
        if (isEditing && outsourcingToEdit) {
            const outsourced = {
                ...outsourcingToEdit,
                name: values.name !== undefined ? values.name : '',
                phone: values.phone !== undefined ? values.phone : '',
                email: values.email !== undefined ? values.email : [],
                category: values.category !== undefined ? values.category : '',
                cuil: values.cuil !== undefined ? values.cuil : '',
            }
            onSubmitOutsourcing(outsourced)
        } else {
            const outsourced = {
                name: values.name !== undefined ? values.name : '',
                phone: values.phone !== undefined ? values.phone : '',
                email: values.email !== undefined ? values.email : [],
                category: values.category !== undefined ? values.category : '',
                cuil: values.cuil !== undefined ? values.cuil : '',
            }
            onSubmitOutsourcing(outsourced)
        }
    }

    const getInitialValues = () => {
        return {
            name: outsourcingToEdit.name ? outsourcingToEdit.name : undefined,
            phone: outsourcingToEdit.phone ? outsourcingToEdit.phone : undefined,
            email: outsourcingToEdit.email ? outsourcingToEdit.email : undefined,
            category: outsourcingToEdit.category ? outsourcingToEdit.category : undefined,
            cuil: outsourcingToEdit.cuil ? outsourcingToEdit.cuil : undefined,
        }
    }

    const clearWorkOrder = () => {
        form.resetFields()
    }

    return (
        <Grid>
            <Form onFinish={handleSubmit} form={form} initialValues={isEditing && getInitialValues()}>
                <Row>
                    <Col xs={12} md={4}>
                        <Form.Item name="name" rules={[{ required: true, message: 'Por favor, ingrese razón social' }]}>
                            <Input placeholder="Razón social"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name="cuil" rules={[{ required: true, message: 'Por favor, ingrese CUIL/CUIT' }]}>
                            <Input type='number' placeholder="CUIL/CUIT"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name="category" rules={[{ required: true, message: 'Por favor, ingrese rubro' }]}>
                            <Input placeholder="Rubro"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="phone" rules={[{ required: true, message: 'Por favor, ingrese un teléfono' }]}>
                            <Input type='number' placeholder="Teléfono"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="email" rules={[{ required: true, message: 'Por favor, ingrese un email' }]}>
                            <Input placeholder="Email"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                {isEditing ? 'Actualizar' : 'Cargar'}
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button onClick={clearWorkOrder} loading={loading}>
                                {isEditing ? 'Restablecer' : 'Limpiar'}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Grid>
    )

})

FormOutsourcing.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmitOutsourcing:PropTypes.func.isRequired,
    isEditing:PropTypes.bool,
    outsourcingToEdit: PropTypes.object,
}

export default FormOutsourcing